/**
 * Employee Document Locker (self) contracts — M03 HRIS Wave 8.3.
 *
 * Read-only surface mounted at `GET /employees/me/documents`. Returns only
 * the rows from `platform.employee_documents` that belong to the current
 * employee. The full HR-side document module owns writes/uploads.
 */
import { z } from 'zod';

import { TenantIdSchema } from '../common/identifiers.js';

import { EmployeeIdSchema } from './employee.js';

export const MyDocumentStatusSchema = z.enum([
  'pending_upload',
  'uploaded',
  'under_review',
  'verified',
  'rejected',
  'expired',
]);
export type MyDocumentStatus = z.infer<typeof MyDocumentStatusSchema>;

export const MyDocumentSchema = z.object({
  id: z.string().uuid(),
  tenantId: TenantIdSchema,
  employeeId: EmployeeIdSchema,
  definitionId: z.string().uuid(),
  title: z.string(),
  status: MyDocumentStatusSchema,
  expiryDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullable(),
  verifiedAt: z.string().datetime({ offset: true }).nullable(),
  rejectionReason: z.string().nullable(),
  notes: z.string().nullable(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type MyDocument = z.infer<typeof MyDocumentSchema>;

export const ListMyDocumentsResponseSchema = z.object({
  items: z.array(MyDocumentSchema),
});
export type ListMyDocumentsResponse = z.infer<typeof ListMyDocumentsResponseSchema>;
